import { makeVar } from '@apollo/client'

export const customCoverRefreshCountVar = makeVar(0)
